import { render, staticRenderFns } from "./PricingLayout.vue?vue&type=template&id=6f0e226e&scoped=true&"
import script from "./PricingLayout.vue?vue&type=script&lang=js&"
export * from "./PricingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e226e",
  null
  
)

export default component.exports